<template>
  <div class="formAverbacao">
    <div class="d-flex justify-content-end pt-2 border-top">
      <div class="d-inline-block">
        <button v-if="!showForm"
                class="btn btn-sm btn-primary"
                type="button"
                @click="toggleForm">
          Adicionar
        </button>
      </div>
    </div>

    <form v-if="showForm"
          class="boxAverbacao"
          name="formAverbacao"
          novalidate
          @submit.prevent="onClickAverbacao">
      <div class="boxAverbacao_header">
        <h2 class="boxAverbacao_header_title">
          {{ edit ? 'Editar Averbação' : 'Nova Averbação' }}
        </h2>
      </div>

      <div class="boxAverbacao_content">
        <div class="row">
          <div class="col-12">
            <div class="col-6 col-sm-4 col-lg-3">
              <div class="form-group mb-2">
                <label class="mb-0"
                       for="date">Data Averbação</label>
                <input id="date"
                       v-model="averbacao.data_averbacao"
                       v-mask="`99/99/9999`"
                       v-validate="`date_format:yyyy-MM-dd|date_between:1500-01-01,${limitDate}`"
                       :class="{ 'is-invalid': errors.has('data_averbacao') }"
                       :disabled="averbacao.origem && averbacao.origem == 'SOFIA_GED'"
                       class="form-control form-control-sm"
                       maxlength="10"
                       name="date"
                       placeholder="00/00/0000"
                       required
                       type="date">
                <small v-if="errors.has('date')"
                       class="invalid-feedback">{{ errors.first('date') }}</small>
              </div>
            </div>
          </div>
        
          <div class="col-4 ResumoAverbacoes-addBox__content">
            <div class="form-group ml-3">
              <span class="custom-control custom-switch mr-4">
                <input
                  id="averb_acrescida_certidao"
                  v-model="averbacao.averb_acrescida_certidao"
                  class="custom-control-input"
                  name="tipo_registro1"
                  type="checkbox"
                  @keyup.enter="averbacao.averb_acrescida_certidao = !averbacao.averb_acrescida_certidao">
                <label
                  class="custom-control-label"
                  for="averb_acrescida_certidao">Averbação acrescida na certidão</label>
              </span>
            </div>
          </div>

          <div class="col-4 ResumoAverbacoes-addBox__content">
            <div class="form-group">
              <span class="custom-control custom-switch mr-4">
                <input
                  id="averb_impressa_livro"
                  v-model="averbacao.averb_impressa_livro"
                  class="custom-control-input"
                  name="tipo_registro2"
                  type="checkbox"
                  @keyup.enter="averbacao.averb_impressa_livro = !averbacao.averb_impressa_livro">
                <label
                  class="custom-control-label"
                  for="averb_impressa_livro">Averbação impressa no livro</label>
              </span>
            </div>
          </div>

          <div v-if="!!propTransporte"
               class="col-4 ResumoAverbacoes-addBox__content">
            <div class="form-group">
              <span class="custom-control custom-switch mr-4">
                <input
                  id="averb_impressa_transporte"
                  v-model="averbacao.averb_impressa_transporte"
                  class="custom-control-input"
                  name="tipo_registro2"
                  type="checkbox"
                  @keyup.enter="averbacao.averb_impressa_transporte = !averbacao.averb_impressa_transporte">
                <label
                  class="custom-control-label"
                  for="averb_impressa_transporte">Averbação impressa no transporte</label>
              </span>
            </div>
          </div>

          <div class="col-7"
               data-tooltip="Escolha a minuta">
            <div class="form-group">
              <div class="tooltipHelp"
                   data-tooltip="A minuta selecionada aqui será apresentada na área de texto abaixo para edição">
                <label class="label">Escolha a minuta</label>
                <icon-svg icon="helpCircle"
                          class="iconBlue" />
              </div>

              <select id="titulo_minuta"
                      ref="titulo_minuta"
                      v-model="averbacao.texto_averbacao"
                      class="form-control form-control-sm"
                      name="titulo_minuta"
                      :disabled="!minutas.length || (averbacao.origem && averbacao.origem == 'SOFIA_GED')">
                <option selected
                        :value="''">
                  Selecione
                </option>
                <option v-for="(minuta, index) in minutas"
                        :key="`titulo_minuta${_uid}_${index}`"
                        :value="minuta.descricao">
                  {{ minuta.titulo }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group mb-2">
              <textarea id="averbacao"
                        v-model="averbacao.texto_averbacao"
                        v-validate="'required|min:10'"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': errors.has('averbacao') }"
                        :disabled="averbacao.origem && averbacao.origem == 'SOFIA_GED'"
                        minlength="10"
                        name="averbacao"
                        placeholder="Digite a averbação"
                        required
                        rows="2"
                        type="text" />
              <small v-if="errors.has('averbacao')"
                     class="invalid-feedback">{{ errors.first('averbacao') }}</small>
            </div>
          </div>
        </div>

        <div class="row no-gutters justify-content-end">
          <div class="d-inline-block">
            <button class="btn btn-sm btn-danger mr-1"
                    title="Cancelar"
                    type="button"
                    @click="toggleForm">
              Cancelar
            </button>

            <button class="btn btn-sm btn-primary"
                    :title="edit ? 'Editar averbação' : 'Adicionar averbação'"
                    type="submit">
              {{ this.edit ? 'Editar Averbação' : 'Adicionar Averbação' }}
            </button>
          </div>
        </div>
      </div>
    </form>

    <b-modal ref="modalCertificados"
             hide-footer
             title="Selecione um certificado"
             size="lg">
      <grid-certificados
        v-if="certificados && certificados.length > 0"
        :certificados="certificados"
        @onSelectCertificado="onSelectCertificado" />
    </b-modal>
  </div>
</template>

<script>
  import moment from "moment"

  import GridCertificados from './GridCertificados'

  /* services */
  import { rei } from "@/services/api"
  import SofiaSignerService from "@/services/SofiaSignerService"
  import MinutasService from "@/services/MinutasService"
  import BryService from '@/services/Assinaturas/BryService'
  import AverbacoesService from "@/services/Registros/AverbacoesService"

  const AVERBACAO_DFLT = {
    data_averbacao: new Date().toISOString().split('T')[0],
    texto_averbacao: '',
    averb_acrescida_certidao: false,
    averb_impressa_livro: false,
    averb_impressa_transporte: false
  }

  export default {
    name: "FormAverbacao",
    components: {
      GridCertificados
    },
    props: [ 'registro', 'averb', 'propTransporte' ],
    data () {
      return {
        edit: false,
        showForm: false,
        certificados: null,
        certificadoSelecionado: null,
        formData: {
          date: '',
          text: ''
        },
        objSuccess: {
          type: 'success',
          title: ''
        },
        objError: {
          title: 'Erro!',
          text: '',
          type: 'error',
          confirmButtonText: 'Ok'
        },
        averbacao: Object.assign({}, AVERBACAO_DFLT),
        minutas: [],
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
        crud: null,
        livroDeRegistro: null,
        certificateData: null,
      }
    },
    watch: {
      averb: function (newVal) {
        if ((Object(newVal) !== null) && this.edit) {
          this.averbacao = {
            ...newVal,
            data_averbacao: moment(String(newVal.data_averbacao)).format('YYYY-MM-DD'),
          }
        }
        /* if ((Object(newVal) !== null) && this.edit) {
          this.formData = {
            documento_id: newVal.documento_id,
            text: newVal.texto,
            date: moment(String(newVal.data_averbacao)).format('DD/MM/YYYY'),
          }
        } else {
          this.$validator.reset()
          this.formData = {
            text: null,
            date: null,
          }
        } */
      }
    },
    async mounted () {
      
      let tipoRegistro = this.tipoRegistro && this.tipoRegistro == 'CR' ? 'C' : this.tipoRegistro

      const minutas = await MinutasService.getMinuta ({
        cartorio_id: this.$store.state.auth.cartorio_id,
        perPage: 100,
        page: 1,
        tipo_registro: tipoRegistro
      })
      this.minutas = minutas.data
    },
    methods: {
      toggleForm () {
        if (this.edit) {
          this.edit = false
        }
        this.$validator.reset()

        this.formData = {
          text: null,
          date: null,
        }

        //this.$emit('onUpdateAverb')
        this.showForm = !this.showForm
      },
      openForEdit () {
        this.edit = true
        this.showForm = true
      },
      onSelectCertificado (certificado) {
        this.certificadoSelecionado = certificado

        // Fechando modal
        this.$refs.modalCertificados.hide()

        // Anulando certificados obtidos
        this.certificados = null

        // Fazendo upload dos arquivos
        this.converterParaPDFA()
      },
      converterParaPDFA () {
        /*if (this.edit) {
          editarAverbacao(this.formData.documento_id, this.formData.date, this.formData.text)
            .then((res) => {
              this.assinarBase64(res.data.arquivoPDFA, res.data.arquivoBase64, res.data.documentoAverbacao)
            }).catch(this.closeLoaderWithError)
        } else {
          incluirAverbacao(this.formData.date, this.formData.text, this.registro.registro_id).then((res) => {
            this.assinarBase64(res.data.arquivo, res.data.arquivoBase64, res.data.documentoAverbacao)
          }).catch(this.closeLoaderWithError)
        }*/
      },
      assinarBase64 (arquivo, arquivoBase64, documentoAverbacao) {
        const { posicao } = this.certificadoSelecionado
        const callbackData = {
          arquivo_id: arquivo.arquivo_id,
          documento_id: documentoAverbacao.documento_id
        }
        const callbackUrl = rei.defaults.baseURL + '/averbacao-p7s'

        SofiaSignerService.assinarP7S(posicao, arquivoBase64, callbackData, callbackUrl).then(() => {
          objSwal.success.title = 'Processo finalizado'
          objSwal.success.text = ''
          NProgress.done()
          this.$store.dispatch('auth/loader', {text: '', active: false}).then(res => res)

          Swal.fire(objSwal.success).then(() => {
            this.toggleForm()
            return this.$emit('onUpdateList')
          })
        }).catch(this.closeLoaderWithError)
      },
      closeLoaderWithError (error) {
        this.objError.text = error.response.data.message
        NProgress.done()
        this.$store.dispatch('auth/loader', { text: '', active: false }).then(()=> {})
        Swal.fire(this.objError)
      },
      onClickAverbacao () {
        this.$validator.validate().then(resp => {
          let invalids = document.querySelectorAll('.is-invalid')

          if (resp && invalids.length === 0) {
            if (this.edit) {
              this.crud = 'update'
            } else {
              this.crud = 'store'
            }

            // Só chamamos o certificado existe o livro de registro e a averbação impressa no livro estiver selecionado
            if (this.livroDeRegistro) {
              this.averbacao.averb_impressa_livro ? this.obterCertificados() : this.direcionaCRUD(false)
            } else {
              this.direcionaCRUD(false)
            }
          }
        })
      },
      async direcionaCRUD (realizarAssinatura = true) {
        if (this.crud === 'store') {
          this.gravarAverbacao(true, realizarAssinatura)

        } else if (this.crud === 'update') {
          this.averbacao.origem && this.averbacao.origem === 'SOFIA_GED' ? this.atualizaAverbacaoGED(realizarAssinatura) : this.atualizaAverbacao(realizarAssinatura)

        } else if (this.crud === 'destroy') {
          this.excluirAverbacao(realizarAssinatura)
        }
      },
      gravarAverbacao (showAlert = true, realizarAssinatura = true) {
        NProgress.start()
        loader({ text: 'Aguarde...', active: true })

        // Manda pra api de store averbacoes
        AverbacoesService.incluirAverbacao(this.registro.registro_id, this.averbacao).then(async (res) => {
          const response = res.data
          try {
            // Realiza a assinatura
            if (realizarAssinatura && response.documentoLivroDeRegistro) {
              await this.assinaturaAverbacao(response.documentoLivroDeRegistro)
            }

            if (showAlert) {
              // Mensagem de sucesso
              objSwal.success.title = "Averbação cadastrada com sucesso!"
              objSwal.success.text = ''
              objSwal.success.html = ''
              await Swal.fire(objSwal.success)
            }

            this.$emit('onUpdateList')
          } catch (e) {
            throw e
          }
        })
          .catch(async (error) => {
            if (showAlert) {
              const message = getErrors(error)

              return displayMessage('error', 'Erro!', message.message)
            }
          })
          .finally(() => {
            this.crud = null
            this.certificados = null
            this.certificadoSelecionado = null
            this.certificateData = null

            NProgress.done()
            loader({ text: '', active: false })
          })
      },
      atualizaAverbacao (realizarAssinatura = true) {
        NProgress.start()
        loader({ text: 'Aguarde...', active: true })

        // Manda pra api de update averbacoes
        AverbacoesService.atualizarAverbacao(this.averbacao.documento_id, this.averbacao).then(async (res) => {
          const response = res.data
          try {
            // Realiza a assinatura
            if (realizarAssinatura && response.documentoLivroDeRegistro) {
              await this.assinaturaAverbacao(response.documentoLivroDeRegistro)
            }

            // Mensagem de sucesso
            objSwal.success.title = "Averbação atualizada com sucesso!"
            objSwal.success.text = ''
            objSwal.success.html = ''

            await Swal.fire(objSwal.success)
          } catch (e) {
            throw e
          }
        })
          .catch(async (error) => {
            const message = getErrors(error)

            return displayMessage('error', 'Erro!', message.message)
          })
          .finally(() => {
            this.crud = null
            this.certificados = null
            this.certificadoSelecionado = null
            this.certificateData = null
            this.$emit('onUpdateList')
            this.toggleForm ()
            NProgress.done()
            loader({ text: '', active: false })
          })
      },

      async assinaturaAverbacao (documentoLivroDeRegistro) {
        try {
          // Guarda o certificateData para quando assinarmos o Livro de Registro.
          this.certificateData = this.certificadoSelecionado.certificateData

          // Inicia a assinatura
          const iniciaAssinatura = await BryService.startSigning(this.certificateData, documentoLivroDeRegistro.documento_id)

          // Trata o objeto da assinatura
          const assinaturasObj = iniciaAssinatura.assinaturasInicializadas.map(({ nonce, messageDigest }) => {
            return BryService.prepareContentForSignature(messageDigest, nonce)
          })

          const { certId } = this.certificadoSelecionado

          // Digita a senha do certificado
          const { assinaturas } = await BryService.signBase64Content(certId, assinaturasObj)

          // Finaliza a assinatura
          await BryService.endSigning(iniciaAssinatura.nonce, assinaturas)
        } catch (e) {
          /* carregando dados */
          await this.init()

          console.error(e)
          throw "Erro ao assinar"
        } finally {
          this.editTextoAverbacao = ''
        }
      },
      async obterCertificados () {
        loader({ text: 'Validando extensão...', active: true })

        if (!BryService.isExtensionInstalled()) {
          loader({ text: '', active: false })

          objSwal.info.title = 'Extensão não instalada'
          objSwal.info.text = 'A extensão para assinatura digital não está instalada no seu navegador. Deseja instalar agora?'
          objSwal.info.html = ''
          objSwal.info.confirmButtonText = 'Instalar'
          objSwal.info.showCancelButton = true
          objSwal.info.cancelButtonText = 'Não'

          return Swal.fire(objSwal.info).then(({ value }) => {
            if (value) {
              try {
                BryService.getExtension()
              } catch (e) {
                this.onLoginError('Erro', e.message)
              } finally {
                this.editTextoAverbacao = ''
              }
            }
          })
        }
      },

      atualizaAverbacaoGED (realizarAssinatura = true) {
        NProgress.start()
        loader({ text: 'Aguarde...', active: true })

        // Manda pra api de update averbacoes
        AverbacoesService.atualizarAverbacaoGED(this.averbacao).then(async (res) => {
          const response = res.data
          try {
            // Realiza a assinatura
            if (realizarAssinatura && response.documentoLivroDeRegistro) {
              await this.assinaturaAverbacao(response.documentoLivroDeRegistro)
            }

            // Mensagem de sucesso
            objSwal.success.title = "Averbação atualizada com sucesso!"
            objSwal.success.text = ''
            objSwal.success.html = ''

            await Swal.fire(objSwal.success)
          } catch (e) {
            throw e
          }
        })
          .catch(async (error) => {
            const message = getErrors(error)

            return displayMessage('error', 'Erro!', message.message)
          })
          .finally(() => {
            this.crud = null
            this.certificados = null
            this.certificadoSelecionado = null
            this.certificateData = null
            this.$emit('onUpdateList')
            this.toggleForm ()
            NProgress.done()
            loader({ text: '', active: false })
          })
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../scss/_utilities/exports";
  .boxAverbacao {
    border: pxToRem(1) dashed $color-dark;

    &_header {
      background-color: $color-dark;

      &_title {
        @extend %titleIcon;
        border: none;
        color: $color-white;

        &:before {
          background-image: url('../../../assets/icons/note-plus-white.svg');
          height: pxToRem(16);
          left: pxToRem(6);
          margin-top: pxToRem(6);
          width: pxToRem(16);
        }
      }
    }

    &_content {
      padding: pxToRem(10);
    }
  }

  .formAverbacao {
    &-show {
      &_title {
        background-color: $sinoreg-blue;
        color: $color-white;
        font-size: pxToRem(22);
        font-weight: 500;
        padding: pxToRem(8);
      }

      &_title-label {
        font-size: pxToRem(22);
        font-weight: 500;
      }

      &_icon {
        fill: $color-white;
      }

      &_label {
        font-size: pxToRem(14);
      }

      &_sublabel {
        font-size: pxToRem(14);
        font-weight: 600;
      }

      &_header{
        &--grey{
          background-color: $sinoreg-card-gray;
          cursor: pointer;
          padding: pxToRem(10) pxToRem(20);
          color: $color-black;
          font-weight: 500;
          font-size: pxToRem(16);
        }

        &--blue{
          background-color: $color-light-blue;
          padding: pxToRem(10) pxToRem(20);
          color: $color-black;
          font-weight: 500;
          font-size: pxToRem(16);
        }

        &--shadow{
          box-shadow: 1px 2px pxToRem(7) $color-gray;
        }

        &--label{
          text-decoration: underline;
          font-size: pxToRem(13);
          margin-bottom: 0;
        }

        &--sublabel{
          font-size: pxToRem(13);
        }
      }

      &_vinculacao-header{
        font-size: pxToRem(12);
      }

      &_vinculacao-divider{
        border-top: 1px solid black;
      }

      &_hr{
        border-top: 1px solid $sinoreg-blue;
      }
    }
    &-addBox {
      &__title {
        background-color: black;
        color: white;
      }
      &__content {
        padding: 10px;
        &--flag {
          padding: 25px 0 0 0;
        }
      }
    }
    &-container {
      min-height: 250px;
      &-item {
          &__title {}
          &__content {}
          border: solid grey 1px;
          padding: 5px;

          .btn {
            border-radius: 50%
          }
      }
    }
    &.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
      display: none;
    }

    &.icons {

      &--black{
        fill: black;
      }
    }

    .icon-done-averb {
      width: 20px;
      height: 20px;
    }

    .icon-close-averb {
      width: 20px;
      height: 20px;
    }

    .flag-averb {
      margin: 0px 30px 0px 30px;

      &-disabled {
        color: #c6c6c6;
        fill: #C6C6C6
      }
    }

    .iconBlue {
      fill: #074f7f;
      height: 1.3rem;
      width: 1.3rem;
      margin-bottom: 3px;
      margin-left: 6px;
    }

    .tooltipHelp::before,
    .tooltipHelp::after {
      --scale: 0;
      --tooltip-color: #F9F9F9;
      --tooltip-color-border: rgba(0,0,0,.3);
      position: absolute;
      z-index: 1;
      content: '';
      bottom: -1rem;
      transition: 35ms;
      transform-origin: bottom center;
      transform: translateX(15%) translateY(44%) scale(var(--scale));
    }

    .tooltipHelp::before {
      content: attr(data-tooltip);
      padding: .5rem;
      width: 38%;
      color: black;
      border-radius: .7rem;
      word-wrap: break-word;
      background: var(--tooltip-color);
      box-shadow: inset 0 0 0.1em var(--tooltip-color-border);
      -webkit-filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
      filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
    }

    .tooltipHelp:hover::before,
    .tooltipHelp:hover::after {
      --scale: 1;
    }

    .tooltipHelp:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border: solid;
      box-shadow: 0px 10px 20px 10;
      border-width: 0px 10px 20px 10px;
      transform: translateX(-100%) translateY(-240%) scale(var(--scale));
      border-color: transparent transparent var(--tooltip-color) transparent;
      -webkit-filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
      filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
    }
  }
</style>

